import PropTypes from 'prop-types';
import { Button } from '@shared/ui';
import i18nInitialState from '@shared/config/translations';

const EMAIL = 'support@test.localhost';

/**
 * "Contact support" CTA rendered in the action slot of the error
 * snackbar. Builds a `mailto:` link pre-populated with the
 * correlationUUID and a small description prompt so the user can
 * forward a useful report to support without copy-pasting headers.
 *
 * Visually: small ghost button using the project's error tone —
 * stays out of the way of the message but remains a clear,
 * tappable secondary action.
 */
const SupportButton = ({ options }) => {
  const { correlationUUID, userUUID } = options;
  const userStr = userUUID ? `UserUUID: ${userUUID}` : '';

  const emailSubject = i18nInitialState.en.errors.supportRequest;
  const emailBody = `${i18nInitialState.en.errors.pleaseEnterDescription}

----------------------

CorrelationUUID: ${correlationUUID}
Timestamp: ${Date.now()}
${userStr}
  `;

  return (
    <a
      href={`mailto:${EMAIL}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`}
      style={{ textDecoration: 'none', marginRight: 8 }}
    >
      <Button variant='ghost' size='sm' style={{ color: 'var(--qhs-st-critical-tx)' }}>
        {i18nInitialState.en.btn.contactSupport}
      </Button>
    </a>
  );
};

SupportButton.propTypes = {
  options: PropTypes.shape({
    correlationUUID: PropTypes.string.isRequired,
    userUUID: PropTypes.string,
  }).isRequired,
};

export default SupportButton;
